// Можно передавать style, className, size
const CurrencyIcon = ({ style = {}, className = '', size = 20 }) => {
	// Если хотите использовать картинку, раскомментируйте строку ниже и добавьте свой путь
	return <img src={require('../assets/frags.png')} alt="frags" style={{ width: size, height: size, ...style }} className={className} />;

	// По умолчанию — эмодзи
	// return (
	// 	<span style={{ fontSize: size, verticalAlign: 'middle', ...style }} className={className}>
	// 		😋
	// 	</span>
	// );
};

export default CurrencyIcon; 